export enum RefundOption {
    REDUCE = "Reduce Booking Value",
    REDUCE_AND_RETURN = "Reduce Booking Value and Return Payment",
    RETURN_PAYMENT = "Return Payment Only",
    CHANGE_GUEST_QUANTITY = "Change Guest Quantity",
    CHANGE_EQUIPMENT_QUANTITY = "Change Equipment Quantity",
    CHANGE_MERCHANDISE_QUANTITY = "Change Merchandise Quantity",
    REFUND_PAYMENT = "Refund Payment",
    REVERSE_FUNDING = "Reverse Funding",
}

export enum RefundSelectOption {
    NONE = "none",
    FULL = "full",
    PARTIAL = "partial",
}
